export default __webpack_public_path__ + "static/media/Check.3bf8364f.svg";